<template>
    <v-navigation-drawer
        app
        clipped
        light
        color="white"
        class="roma-drawer"
        :expand-on-hover="expand"
        :mini-variant="dpDrawer"
        :v-model="dpDrawer"
        :permanent="$vuetify.breakpoint.mdAndUp"
        :temporary="!$vuetify.breakpoint.mdAndUp ? true : false"
    >
        <!-- options list -->
        <v-list nav rounded>
            <!-- items -->
            <v-list-item
                link
                v-for="(link, i) in options"
                :key="i"
                :to="{ name: link.to }"
                exact-active-class="roma-active"
                :class="link.customClasses"
            >
                <v-list-item-action class="drawer-item">
                    <img :src="link.icon" alt class="default" />
                    <img :src="link.iconActive" class="active" alt />
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title class="roma-cabin-bold">{{
                        link.title
                    }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    props: ["dpDrawer"],
    data() {
        return {
            options: [
                {
                    title: "Mis clases",
                    icon: require("@/assets/icons/my_class_icon.svg"),
                    iconActive: require("@/assets/icons/online-course.svg"),
                    to: "Lesson",
                    customClasses: ""
                },
                {
                    title: "Tareas por revisar",
                    icon: require("@/assets/icons/tasks-reviews-icon.svg"),
                    iconActive: require("@/assets/icons/tasks-reviews-icon.svg"),
                    to: "Tareas",
                    customClasses: "d-xl-none"
                },
                {
                    title: "Progreso",
                    icon: require("@/assets/icons/progress-icon.svg"),
                    iconActive: require("@/assets/icons/progress-icon.svg"),
                    to: "Progreso",
                    customClasses: "d-xl-none"
                }
            ],
            expand: false,
            mini: false
        };
    },
    computed: {
        ...mapGetters({
            drawer: "getDrawer"
        }),
        getDrawer: {
            get() {
                return this.drawer;
            },
            set(value) {
                return value;
            }
        }
    },
    methods: {
        progress(value) {
            if (value <= 25) {
                this.color = "secondary";
            } else if (value >= 26 && value <= 49) {
                this.color = "purple";
            } else if (value >= 50 && value <= 75) {
                this.color = "accent";
            } else if (value >= 76 && value <= 90) {
                this.color = "blueMedium";
            } else {
                this.color = "green";
            }
            return this.color;
        }
    }
};
</script>

<style lang="scss" scope>
.roma-drawer {
    min-height: 500px;
    .custom-badge {
        position: absolute;
    }
    .v-list-item {
        margin-top: 1rem;
        .drawer-item {
            // background-color: #bada55;
            position: relative;
            margin-right: 1rem !important;
            margin-left: 1rem;
            transition: margin 0.25s ease;
            .active {
                position: absolute;
                width: 100%;
                height: auto;
            }
        }
        .v-list-item__action img {
            // width: 42px;
        }
        .v-list-item__content,
        .v-list-item__action img {
            transition: color 0.5s ease, filter 0.5s ease;
            // color: $orange;
        }
        .default {
            position: absolute;
            width: 100%;
        }
        .active {
            display: none;
        }

        // active styles
        &.v-list-item--active.v-list-item--link {
            .active {
                display: block;
            }
            .default {
                display: none;
            }
            .v-list-item__content {
                color: $morado;
            }
        }
    }

    .general-advance {
        position: absolute;
        left: auto;
        right: auto;
        bottom: 20px;

        .title-progress {
            font-family: "Cabin Regular";
            font-size: 20px;
        }

        .progress-value {
            font-size: 28px;
            color: #000000;
        }
    }
}
</style>
